import React from 'react';
import { Button } from 'react-toolbox/lib/button';
import AddButton from 'components/AddButton';
import RemoveButton from 'components/RemoveButton';
import styles from 'components/SelectionActionBar.css';

const SelectionActionBar = ({
  actionsDisabled,
  addText,
  onAdd,
  onBack,
  onRemove,
  removeText,
  selectedCount,
}) =>
  <div className={styles.container}>
    <Button icon="arrow_back" className={styles.backButton} onClick={onBack} />
    <div className={styles.selectedCountContainer}>
      <span className={styles.selectedCount}>
        {selectedCount}
      </span>
      <span className={styles.selectedLabel}>selected</span>
    </div>
    <div className={styles.buttonContainer}>
      {onAdd &&
        <AddButton
          label={addText || 'Add'}
          className={styles.addButton}
          onClick={onAdd}
          disabled={actionsDisabled}
        />}
      {onRemove &&
        <RemoveButton
          label={removeText || 'Remove'}
          className={styles.removeButton}
          onClick={onRemove}
          disabled={actionsDisabled}
        />}
    </div>
  </div>;

export default SelectionActionBar;
